// constantContent Copyright 2022 Rebecca L Beaudet
const CORP_NAME = 'The Com Collab, LLC';
const CREDENTIALS = 'M.Ed.';
const FOUNDER = 'Rebecca Beaudet';
const callToActionButton = 'Learn More!';
const EMAIL = 'thecomcollab@gmail.com';
const SUPPORT_EMAIL = EMAIL;
const ONLINE_LEARNING_ROUTE = 'learn';
const INTRO_VIDEO_LINK = '_zYdjc5mp60';
const LEARNING_PORTAL_NAME = `${CORP_NAME} Online Learning`;
const MAIN_BANNER = '/img/2025_banner.jpg';
const STANDARD_HOURS = `Wednesdays 9 a.m. to 4 p.m.`;
const HOURLY_RATE_IN_PERSON = '$125';
const HOURLY_RATE_IN_VIRTUAL = '$85';
const RATE_GROUP = {
    heading: 'Rates',
    group: [
        { title: `In-Person: ${HOURLY_RATE_IN_PERSON} per hour` },
        { title: `Virtual: ${HOURLY_RATE_IN_VIRTUAL} per hour` },
    ],
};
const STD_PORTAL_VIDEO_RATE = 2000; // rate in pennies (This is how Stripe understands it)
const logoPath = '/img/logo2.jpg';
const logoDesc = 'Company Logo: A small red heart being held by two hands on a white background';
const founderHeadshot = '/img/small500byHeadshot.jpg';
const headShotAltText = `Headshot of ${FOUNDER}, a brunette, white woman with green-framed glasses. Her hair is straight and she is wearing a purple T-shirt and grey sweater.`;
export { CORP_NAME, callToActionButton, CREDENTIALS, FOUNDER, EMAIL, logoPath, logoDesc, founderHeadshot, headShotAltText, ONLINE_LEARNING_ROUTE, INTRO_VIDEO_LINK, SUPPORT_EMAIL, LEARNING_PORTAL_NAME, MAIN_BANNER, STANDARD_HOURS, HOURLY_RATE_IN_PERSON, HOURLY_RATE_IN_VIRTUAL, RATE_GROUP, STD_PORTAL_VIDEO_RATE, };
